module.exports = __webpack_public_path__ + "static/media/buynowfr.a9067b08.png";